import React, { useEffect, useState } from "react";
import "../styles/remittance.css";
import { fetchCustomerRemittance } from "../services/customerRemittanceService";
import { formatAmount } from "../utils/formatAmount";

const convertToInputDate = (dateStr) => {
  if (!dateStr || dateStr === "0001-01-01") return "";

  if (dateStr.includes("-") && dateStr.length === 10) {
    return dateStr;
  }

  return "";
};

function Remittance() {
  const today = new Date();

  const previousMonth = new Date();
  previousMonth.setMonth(previousMonth.getMonth() - 1);

  const formatDate = (date) => {
    return date.toISOString().split("T")[0];
  };

  const [fromDate, setFromDate] = useState(formatDate(previousMonth));
  const [toDate, setToDate] = useState(formatDate(today));

  const [data, setData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);

  useEffect(() => {
    const loadRemittance = async () => {
      try {
        const res = await fetchCustomerRemittance(fromDate, toDate);


        // Separate TOTAL row
        const totalRow = res.find(
          (item) => item.description === "TOTAL"
        );

        if (totalRow) {
          setTotalAmount(totalRow.amount || 0);
        }

        // Exclude TOTAL row from table
        const normalRows = res.filter(
          (item) => item.description !== "TOTAL"
        );

        const formatted = normalRows.map((item) => ({
          date: convertToInputDate(item.transaction_date),
          description: item.description,
          remarks: item.remarks?.trim() || "-",
          amount: item.amount || 0,
          rowColor: item.row_color,
        }));

        setData(formatted);
      } catch (err) {
        console.error(err);
      }
    };

    loadRemittance();
  }, [fromDate, toDate]);

  return (
    <div className="remittance-page">
      <div className="remittance-container">
        <h2>Remittance History</h2>

        <div className="remittance-date-filter">
          <div>
            <label>From</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div>
            <label>To</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
        </div>

        <p className="remittance-date-range">
          From {fromDate} To {toDate}
        </p>

        <div className="remittance-table-wrapper">
          <table className="remittance-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Remarks</th>
                <th>Amount</th>
              </tr>
            </thead>

            <tbody>
              {data.map((t, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: t.rowColor || "",
                  }}
                >
                  <td>{t.date || "-"}</td>
                  <td>{t.description}</td>
                  <td>{t.remarks}</td>
                  <td style={{ textAlign: "right" }}>
                    {formatAmount(t.amount)}
                  </td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr className="total-row">
                <td colSpan="3">
                  <strong>TOTAL</strong>
                </td>
                <td style={{ textAlign: "right" }}>
                  <strong>{formatAmount(totalAmount)}</strong>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Remittance;